module.exports = __webpack_public_path__ + "static/Hero-scot.98611fc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-scot.jpg
// module id = 496
// module chunks = 153228935106781